import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import actions from '@src/redux/actions';
import { Typography } from '@mui/material';
import {
  LibraryMusicRounded,
  MovieFilterRounded,
  ChevronRightRounded,
} from '@mui/icons-material';
import Speed from '@src/components/Speed';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import route from '@src/constants/route';
import CustomTypography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import MenuVoice from '../MenuVoice';

import { StyledToolBar, StyledSrtProjectButton } from './index.style';

const ToolBar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const { audioType, speed, fileId } = useSelector(
    (state) => state.dubbingRequest,
  );
  const { user } = useSelector((state) => state.auth);

  const { getFeatureValue } = useFeatureFlags();
  const createSrtProjectEnabled = getFeatureValue(
    FEATURE_KEYS.CREATE_SRT_PROJECT,
    { userId: user.id, email: user.email, phoneNumber: user.phoneNumber },
  );

  const handleChangeSpeed = (name, value) => {
    dispatch(actions.dubbingRequest.updateDubbingRequestByKey('speed', value));
  };

  const handleNavigateToSrtProject = () => {
    history.push(route.PROJECTS);
  };
  return (
    <StyledToolBar>
      <MenuVoice />
      <div className="speed">
        <Speed
          currentSpeed={speed}
          onChange={handleChangeSpeed}
          disabled={!fileId}
          width="35px"
        />
      </div>
      <div className="border-horizontal">
        {/* <AudioFormat /> */}
        <div className="icon-content">
          <LibraryMusicRounded color="iconPrimary" sx={{ fontSize: 20 }} />
          <Typography variant="body2" className="title">
            {audioType}
          </Typography>
        </div>
      </div>
      {createSrtProjectEnabled && (
        <StyledSrtProjectButton onClick={handleNavigateToSrtProject}>
          <MovieFilterRounded sx={{ fontSize: 24, color: COLOR.white }} />
          <CustomTypography variant="body-16-medium" color={COLOR.white}>
            {t('projectSRT')}
          </CustomTypography>
          <ChevronRightRounded sx={{ fontSize: 24, color: COLOR.white }} />
        </StyledSrtProjectButton>
      )}
    </StyledToolBar>
  );
};

export default ToolBar;
